import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CommonUtilitiesService {




  /**
   * Converts a string to a number, and handles removing basic info such as
   * commas from the value if originally a string itself,
   * and could be used with numer check logic such as ,
   * typeof str !== "number"
   * @param str
   * @param isReplaceCommas
   * @returns
   */
  /*public static convertStringToNumber(str, isReplaceCommas = true){

    if(isReplaceCommas)
      if(typeof str !== "number")
        str = str.replace(/,/g, "");

    if(!isNaN(str)){
      return Number(str)
    }
    else {
      return str;
    }
  }*/

    public static convertStringToNumber(str: any, isReplaceCommas = true): number {
      if (typeof str === "number") return str;
    
      if (!str || typeof str !== "string") return NaN;
    
      if (isReplaceCommas) {
        str = str.replace(/,/g, "").replace("%", "").trim();
      }
    
      // Handle "3 Months", "26 Days", etc.
      const lower = str.toLowerCase();
    
      const monthMatch = lower.match(/(\d+)\s*month/);
      if (monthMatch) return parseInt(monthMatch[1]);
    
      const dayMatch = lower.match(/(\d+)\s*day/);
      if (dayMatch) return parseInt(dayMatch[1]) / 30; // approx in months

      // Handle values that include currency text (e.g., "2880000.0 SAR" or "USD 2880000.0")
      const numericMatch = str.match(/-?\d+(?:\.\d+)?/);
      if (numericMatch) {
        return Number(numericMatch[0]);
      }
    
      // Try to convert as plain number
      return !isNaN(str as any) ? Number(str) : NaN;
    }
    
}
